import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 1FC39B1E-567E-452C-B923-581F9A90F06D
 * name seat-legroom-normal
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/seat-legroom-normal.svg
 * tags
 */
export const SeatLegroomNormalIcon = createSvgIcon(<><path d="M5,12V3H3V12A5,5 0 0,0 8,17H14V15H8A3,3 0 0,1 5,12M20.5,18H19V11A2,2 0 0,0 17,9H12V3H6V11A3,3 0 0,0 9,14H16V21H20.5A1.5,1.5 0 0,0 22,19.5A1.5,1.5 0 0,0 20.5,18Z" /></>, 'SeatLegroomNormalIcon');
export default SeatLegroomNormalIcon